module.exports = __webpack_public_path__ + "media/images/author/author-3-26df870f46e3ea3299d6bef9acab4537.jpg";